export const blockIconsAudioandvideoLibraryBooks = (
	<span className='material-symbols-outlined'>library_books</span>
);
